export const COLORS={
    primary:"#2e8dd3",
    disable:'#101'
}